import { Component, OnInit } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { SiteService } from '../_services/site.service';
import { Globals } from 'app/_globals';

declare var google;

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
})
export class SiteMapComponent implements OnInit {

  routeRole: any;

  // Pagination Setup
  pageSize = 20;
  pageNum = 0;
  totalRecords = 0;

  // Site Data
  sites: any = [];

  // Map Setup
  lat = 51.678418;
  lng = 7.809007;
  markers: marker[] = []; // yellow 'marker[]' is declared as an interface at bottom of file for type safety
  latLngBounds: any = false;

  mapZoom = 11;
  mapCenter = { lat: this.lat, lng: this.lng };

  mapStyles = environment.customMapStyle;

  searchDropdownArray: any = [{ label: 'All', value: null }];
  selectedSite: any;

  constructor(
    public mapsAPILoader: MapsAPILoader,
    public router: Router,
    public sitesService: SiteService,
    public globals: Globals
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.initialiseSites();
  }

  // Initalising sites
  public initialiseSites() {
    this.getAllSites();
  }

  // Get all sites
  public getAllSites() {
    this.sitesService.getAllSitesNoPagination()
      .subscribe(data => {
        this.sites = data;
        this.populateMarkers(this.sites);
        this.populateSearchDropdown(this.sites);
      }, err => {
    });
  }

  // Populate Map Markers
  public populateMarkers(sites) {
    this.markers = [];
    sites.forEach(site => {
      this.markers.push({
        lat: site.latitude,
        lng: site.longitude,
        site: site,
        draggable: false
      });
    });
    this.mapsAPILoader.load().then(() => {
      this.latLngBounds = new window['google'].maps.LatLngBounds();
      this.markers.forEach((location) => {
        this.latLngBounds.extend(new window['google'].maps.LatLng(location.lat, location.lng));
      });

      // Don't zoom in too far on only one marker
      if (this.latLngBounds.getNorthEast().equals(this.latLngBounds.getSouthWest())) {
        const extendPoint1 = new google.maps.LatLng(this.latLngBounds.getNorthEast().lat() + 0.01, this.latLngBounds.getNorthEast().lng() + 0.01);
        const extendPoint2 = new google.maps.LatLng(this.latLngBounds.getNorthEast().lat() - 0.01, this.latLngBounds.getNorthEast().lng() - 0.01);
        this.latLngBounds.extend(extendPoint1);
        this.latLngBounds.extend(extendPoint2);
      }

      this.mapCenter = this.latLngBounds.getCenter();
    });
  }

  // Handle Marker Click
  public clickedMarker(m) {
    this.router.navigate(['/' + this.routeRole + '/sites/' + m.site.id]);
  }

  // Search Dropdown Functions
  // Populate Dropdown
  public populateSearchDropdown(sites) {
    for (let i = 0; i < sites.length; i++) {
      const item = {
        label: sites[i].name,
        value: sites[i]
      };
      this.searchDropdownArray.push(item);
    }
  }

  public onSelectedSiteChange(event) {
    if (event === null) {
      this.getAllSites();
    } else {
      this.selectedSite = event;
      this.lat = event.latitude;
      this.lng = event.longitude;
      this.mapZoom = 14;
    }
  }

  zoomChanged(event) {
    this.mapZoom = event;
  }

  centerChanged(event) {
    this.mapCenter = event;
  }

  openWeatherMap() {
    window.open(
      environment.meteoblueWindUrl +
      this.mapCenter.lat + 'N' + this.mapCenter.lng +
      'E115_Europe%2FLondon?variable=wind_streamlines&level=surface&lines=none&mapcenter='
      + this.mapCenter.lat + 'N' + this.mapCenter.lng + '&zoom=' + this.mapZoom);
  }

}

// tslint:disable-next-line:class-name
interface marker {
  lat: number;
  lng: number;
  site: any;
  draggable?: boolean;
}
